import React, { useState, useEffect, useRef } from 'react'
import Select, { components } from 'react-select';
import SectionTitle from '../components/section-title'
import Widget from '../components/widget'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import { Button, Container, Row, Col, Form, Dropdown } from 'react-bootstrap'
import { Redirect } from 'react-router-dom'
import { parseCookies } from 'nookies'
import MUIDataTable from 'mui-datatables';
import { useHistory } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import AsyncSelect from 'react-select/async';
import JoditEditor from "jodit-react";

const AddApp = () => {

    const editor = useRef(null);

    //Setto gli state
    const [allUsers, viewUsers] = useState([{}]);
    const [loading, setLoading] = useState(false);

    // state trattamenti
    const [allTreatments, setAllTreatments] = useState([]);
    const [loadingTreatments, setLoadingTreatments] = useState(false);
    const [selectedTreatment, setSelectedTreatment] = useState(null);
    const [isCreated, setCreated] = useState(false);
    const [showSucc, setSucc] = useState('');
    const [user, setUser] = useState(null);
    const [showErr, setErr] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedOption_1, setSelectedOption_1] = useState(null);
    const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);
    const [content, setContent] = useState('');

    const [useTreatmentPricing, setUseTreatmentPricing] = useState(false);

    const { register, handleSubmit, errors } = useForm();
    const cookies = parseCookies();

    const config = {
        readonly: false,
        height: 'auto',
        placeholder: '',
        language: 'it' // all options from https://xdsoft.net/jodit/doc/
    }

    //Recupero i dati dal db
    useEffect(() => {
        let mounted = true
        const fetch = async () => {
            const users = await axios.get(`${window.$apiEndpoint}/appoiments/fetchCApp`, {
                headers: {
                    "x-access-token": cookies.token
                }
            });
            try {
                if (mounted) {
                    viewUsers(users.data)
                }
            } catch (e) {
                console.log(e)
            }
            setLoading(true)
        }
        fetch();
        return () => {
            mounted = false
        }
    }, [cookies.token]);

    // Fetch trattamenti
    useEffect(() => {
        let mounted = true
        const fetchTreatments = async () => {
            try {
                const res = await axios.get(`${window.$apiEndpoint}/treatments/fetch`, {
                    headers: { "x-access-token": cookies.token }
                });

                // Adatto i dati al formato react-select: {value,label,...extra}
                const options = res.data.map(t => ({
                    value: t.id,
                    label: t.name,
                    name: t.name,
                    price: t.price,
                    notes: t.notes
                }));

                if (mounted) setAllTreatments(options)
                setLoadingTreatments(true)
            } catch (e) {
                console.log(e)
            }
        }
        fetchTreatments();
        return () => { mounted = false }
    }, [cookies.token]);

    //Controllo se siamo nel ora legale o solare
    function isDST(d) {
        let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
        let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
        return Math.max(jan, jul) != d.getTimezoneOffset();
    }

    //Chiamata post per inserimento utente
    const onSubmit = data => {
        const codice_cliente = selectedOption;
        const startDate = data.startDate;
        const endDate = data.endDate;
        // const trattamento = content;
        // const trattamento = selectedTreatment?.name;
        const trattamento = useTreatmentPricing ? selectedTreatment?.name : content;

        const trattamento_html = trattamento.replace(/<[^>]*>?/gm, '');
        const trattamento_html_2 = trattamento_html.replace(/\&nbsp;/g, '');

        // encode
        const trattamento_encoded = encodeURIComponent(trattamento_html_2);

        // PREZZO TRATTAMENTO SELEZIONATO
        const tariffa = selectedTreatment?.price;

        //Controllo se siamo nell'ora legale o solare e a seconda di questo cambio UTC
        const dataSelezionata = new Date(startDate);
        const controlloG = isDST(dataSelezionata);

        if (controlloG === true) {
            //Siamo nell'ora legale
            //Genero le date come servono a Google Calendar
            const data_starDate_Google = startDate + ":00+02:00"
            const data_endDate_Google = endDate + ":00+02:00"

            //Controllo se il codice cliente è selezionato
            if (!codice_cliente) {
                return setErr('Cliente non selezionato')
            }

            //Controllo se il trattamento è stato inserito
            if (!trattamento) {
                return setErr('Si prega di inserire il trattamento')
            }

            axios.get(`${window.$apiEndpoint}/calendar/create-event/${codice_cliente}/${trattamento_encoded}/${data_starDate_Google}/${data_endDate_Google}`, {
                headers: {
                    "x-access-token": cookies.token
                }
            }).then(res => {
                axios.post(`${window.$apiEndpoint}/appoiments/create`, {
                    codice_cliente: codice_cliente,
                    startDate: startDate,
                    endDate: endDate,
                    trattamento: trattamento,
                    /* tariffa: tariffa, */
                    ...(useTreatmentPricing ? { tariffa } : {}),
                    IdGoogle: res.data.Id_Google
                }, {
                    headers: {
                        'x-access-token': cookies.token
                    }
                })
                    .then(res => {
                        setUser(res.data)
                        setTimeout(() => { setCreated(true) }, 2500)
                        setSucc('Appuntamento creato con successo, a breve la pagina verrà ricaricata.')
                    }).catch(err => {
                        setErr('Errore - ' + err.message)
                    })
            })

        } else {
            //Siamo nell'ora Solare
            //Genero le date come servono a Google Calendar
            const data_starDate_Google = startDate + ":00+01:00"
            const data_endDate_Google = endDate + ":00+01:00"

            //Controllo se il codice cliente è selezionato
            if (!codice_cliente) {
                return setErr('Cliente non selezionato')
            }

            //Controllo se il trattamento è stato inserito
            if (!trattamento) {
                return setErr('Si prega di inserire il trattamento')
            }

            axios.get(`${window.$apiEndpoint}/calendar/create-event/${codice_cliente}/${trattamento_encoded}/${data_starDate_Google}/${data_endDate_Google}`, {
                headers: {
                    "x-access-token": cookies.token
                }
            }).then(res => {
                axios.post(`${window.$apiEndpoint}/appoiments/create`, {
                    codice_cliente: codice_cliente,
                    startDate: startDate,
                    endDate: endDate,
                    trattamento: trattamento,
                    /* tariffa: tariffa, */
                    ...(useTreatmentPricing ? { tariffa } : {}),
                    IdGoogle: res.data.Id_Google
                }, {
                    headers: {
                        'x-access-token': cookies.token
                    }
                })
                    .then(res => {
                        setUser(res.data)
                        setTimeout(() => { setCreated(true) }, 2500)
                        setSucc('Appuntamento creato con successo, a breve la pagina verrà ricaricata.')
                    }).catch(err => {
                        setErr('Errore - ' + err.message)
                    })
            })
        }
    }

    //Se lo state isCreated é true eseguo il redirect alla pagina profilo utente
    if (isCreated) {
        // redirect to home if signed up
        return <Redirect to={'/add-appointments'} />;
        //return window.location.reload();
    }

    //Quando Seleziono cliente
    const handleChange = selectedOption => {
        setSelectedOption(selectedOption.value);
        setSelectedOptionLabel("| Cliente: " + selectedOption.label);
    };

    // quando selezioni trattamento
    const handleTreatmentChange = opt => {
        setSelectedTreatment(opt);
    };

    const handleChange_1 = (value) => {
        function addHoursToDate(date, hours) {
            return new Date(new Date(date).setHours(date.getHours() + hours));
        }
        const dataSelezionata = new Date(value);

        //Controllo se siamo nell'ora legale o solare e a seconda di questo cambio UTC

        const controllo = isDST(dataSelezionata)

        if (controllo === true) {
            //Siamo nell'ora legale
            const dataSelezionata = new Date(value);

            const dataPreselezionata = addHoursToDate(dataSelezionata, 3)
            setSelectedOption_1(dataPreselezionata.toISOString().slice(0, -8))

        } else {
            //Siamo nell'ora solare
            const dataSelezionata = new Date(value);

            const dataPreselezionata = addHoursToDate(dataSelezionata, 2)
            setSelectedOption_1(dataPreselezionata.toISOString().slice(0, -8))
        }
    };

    const togglePricingMode = (checked) => {
        setUseTreatmentPricing(checked);
        setErr('');
        if (checked) {
            setContent('');               // passo a trattamento -> svuoto editor
        } else {
            setSelectedTreatment(null);   // passo a cliente -> svuoto select
        }
    };

    return (
        <>
            <SectionTitle title="Inserisci" subtitle="Crea nuovo appuntamento" />
            <Container fluid>
                <Row>
                    <Col xs={12}>
                        <div className="card border-left-warning  shadow h-100 py-6 px-4">
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Form.Row>
                                    <Col xs={6}>
                                        <Form.Group controlId="cliente" >
                                            <Form.Label>Seleziona Cliente:</Form.Label>

                                            {loading ?
                                                <Select value={selectedOption} onChange={handleChange} options={allUsers} />
                                                : <center><Spinner size="sm" animation="border" variant="info" /></center>
                                            }
                                            <pre className="mt-2">Codice Cliente Selezionato: <strong>{selectedOption}</strong> {selectedOptionLabel} </pre>

                                        </Form.Group>
                                    </Col>

                                    <Col>
                                        <Form.Group controlId="startDate" >
                                            <Form.Label>Orario di Arrivo</Form.Label>
                                            <Form.Control type="datetime-local" name="startDate" onChange={(e) => handleChange_1(e.target.value)} ref={register({ required: true })} />
                                        </Form.Group>
                                    </Col>

                                    <Col>
                                        <Form.Group controlId="endDate" >
                                            <Form.Label>Orario di partenza</Form.Label>
                                            <Form.Control type="datetime-local" defaultValue={selectedOption_1} name="endDate" ref={register({ required: true })} />
                                        </Form.Group>
                                    </Col>
                                </Form.Row>

                                <Form.Group>
                                    <Form.Check
                                        type="checkbox"
                                        id="useTreatmentPricing"
                                        label="Usa listino trattamenti"
                                        checked={useTreatmentPricing}
                                        onChange={(e) => togglePricingMode(e.target.checked)}
                                    />
                                    <small className="text-muted">
                                        Se disattivato: usa tariffa cliente e descrizione libera.
                                    </small>
                                </Form.Group>

                                <Form.Row>
                                    {
                                        !useTreatmentPricing ? (
                                            <Form.Group controlId="trattamento" as={Col} >
                                                <Form.Label>Trattamento</Form.Label>
                                                <JoditEditor name="trattamento" value={content} config={config} ref={editor} tabIndex={1} onBlur={newContent => setContent(newContent.target.innerHTML)} onChange={newContent => { }} />
                                            </Form.Group>
                                        ) : (
                                            <Form.Group controlId="trattamento" as={Col} md={6} lg={6}>
                                                <Form.Label>Trattamento</Form.Label>

                                                {loadingTreatments ?
                                                    <Select
                                                        value={selectedTreatment}
                                                        onChange={handleTreatmentChange}
                                                        options={allTreatments}
                                                        placeholder="Seleziona trattamento..."
                                                        formatOptionLabel={(opt, { context }) => {
                                                            // --- COME SI VEDE NEL MENU ---
                                                            if (context === "menu") {
                                                                return (
                                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                                                        <div style={{ minWidth: 0 }}>
                                                                            <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                {opt.name}
                                                                                {opt.notes ? ` (${opt.notes})` : ""}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ fontSize: 18, whiteSpace: "nowrap" }}>
                                                                            €{opt.price}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }

                                                            // --- COME SI VEDE QUANDO È SELEZIONATO ---
                                                            return (
                                                                <div style={{ display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
                                                                    <span style={{ fontSize: 16 }}>
                                                                        {opt.name}
                                                                    </span>
                                                                    {opt.notes ? <span>({opt.notes})</span> : null}
                                                                    <span style={{ fontSize: 16 }}>
                                                                        - {opt.price} €
                                                                    </span>
                                                                </div>
                                                            );
                                                        }}
                                                    />

                                                    : <center><Spinner size="sm" animation="border" variant="info" /></center>
                                                }
                                                <pre className="mt-2">Trattamento Selezionato: <strong>{selectedTreatment?.name}</strong> - {selectedTreatment?.price} €</pre>
                                            </Form.Group>
                                        )
                                    }

                                </Form.Row>
                                {errors.startDate && <p className="my-2" style={{ fontWeight: 'bold', color: '#f15a24' }}>Tutti i campi sono obbligatori</p>}
                                <p className="my-2" style={{ fontWeight: 'bold', color: 'red' }}>{showErr}</p>
                                <p className="my-2" style={{ fontWeight: 'bold', color: 'green' }}>{showSucc}</p>

                                <Button variant="info" size="md" type="submit" style={{ backgroundColor: "#009688", borderColor: "#009688", fontWeight: '600' }}>
                                    Crea Appuntamento
                                </Button>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default AddApp;
